import React from "react";
import { Col, Row } from "antd";
import style from "../../index.module.scss";
import Editor from "components/Editor";
import FieldWithError from "components/FieldWithError";

export default function FieldContentText() {
    return (
        <Row gutter={[0, 20]}>
            <Col span={4} className={style.label}>
                <i className={style.required}>*</i> 题干
            </Col>

            <Col span={18} offset={1}>
                <FieldWithError
                    name="contentText"
                    valuePropName="data"
                    initialValue=""
                    rules={[
                        {
                            required: true,
                            message: "题干必填，请填写题干后再提交保存"
                        }
                    ]}>
                    <Editor data="" />
                </FieldWithError>
            </Col>
        </Row>
    );
}
